import { useMutation } from "react-query";
import api from "../../../services/api/api";
export const useDeleteUser = () => {
  return useMutation((params: { userId: string }) => {
    return api.delete<string, string>(`/deleteUser?userId=${params.userId}`);
  });
};

